/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ComunicazioneOutboxDTO } from '../model/comunicazione-outbox-dto';
// @ts-ignore
import { ComunicazioneOutboxListFilter } from '../model/comunicazione-outbox-list-filter';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelComunicazioneOutboxDTO } from '../model/paged-model-comunicazione-outbox-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    CodaComunicazioniServiceInterface,
    ListComunicazioniOutboxRequestParams,
    ReinviaComunicazioneOutboxRequestParams
} from './coda-comunicazioni.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CodaComunicazioniService extends BaseService implements CodaComunicazioniServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Lista paginata della coda comunicazioni (SUPERADMIN).
     * Filtri opzionali: comune_id, tipo_pratica_id, codice_pratica, canale, evento, stato, da/a sull\&#39;istante di accodamento. Ordinamento predefinito: created_at DESC, size 20. Gli stati sono PENDENTE e IN_CORSO (ancora in lavorazione), INVIATA, FALLITA_DEFINITIVA (tentativi esauriti, reinviabile) e SALTATA_NO_RECAPITO (il destinatario non ha un recapito per il canale: si risolve correggendo l\&#39;anagrafica della domanda, non rilanciando). La risposta NON contiene destinatario, testo del messaggio né dati anagrafici: la riga di coda non li memorizza. Le righe chiuse spariscono dopo la finestra di ritenzione configurata.
     * @endpoint get /api/v1/gestione/comunicazioni-outbox
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listComunicazioniOutbox(requestParameters: ListComunicazioniOutboxRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelComunicazioneOutboxDTO>;
    public listComunicazioniOutbox(requestParameters: ListComunicazioniOutboxRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelComunicazioneOutboxDTO>>;
    public listComunicazioniOutbox(requestParameters: ListComunicazioniOutboxRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelComunicazioneOutboxDTO>>;
    public listComunicazioniOutbox(requestParameters: ListComunicazioniOutboxRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listComunicazioniOutbox.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listComunicazioniOutbox.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comunicazioni-outbox`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelComunicazioneOutboxDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rimette in coda una comunicazione fallita definitivamente (SUPERADMIN).
     * Azzera i tentativi e riporta la riga a PENDENTE: il primo giro del worker la riprende. Non modifica alcun dato della domanda. Ammesso SOLO da FALLITA_DEFINITIVA — rilanciare una riga in attesa la duplicherebbe, una già inviata produrrebbe un secondo messaggio al cittadino: entrambi i casi tornano 422. Ha senso quando la causa era passeggera ed è rientrata (un SMTP tornato su); se invece manca il recapito la riga è SALTATA_NO_RECAPITO e il reinvio non la riguarda.
     * @endpoint post /api/v1/gestione/comunicazioni-outbox/{id}/reinvia
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public reinviaComunicazioneOutbox(requestParameters: ReinviaComunicazioneOutboxRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ComunicazioneOutboxDTO>;
    public reinviaComunicazioneOutbox(requestParameters: ReinviaComunicazioneOutboxRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ComunicazioneOutboxDTO>>;
    public reinviaComunicazioneOutbox(requestParameters: ReinviaComunicazioneOutboxRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ComunicazioneOutboxDTO>>;
    public reinviaComunicazioneOutbox(requestParameters: ReinviaComunicazioneOutboxRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reinviaComunicazioneOutbox.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comunicazioni-outbox/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/reinvia`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ComunicazioneOutboxDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
